const twoDigits = (data) => {
    data = '00' + data;
    return data.substring(data.length - 2);
}

const formatStandard = (date) => {
    if(!date 
        || date === "")
        return "";

    let currentDate = new Date(date);
    let result = twoDigits(currentDate.getDate()) 
        + "." + twoDigits(currentDate.getMonth() + 1) 
        + "." + currentDate.getFullYear();
    return result;
}

const formatTime = (date) => {
    if(!date 
        || date === "")
        return "";

    let currentDate = new Date(date);
    let result = twoDigits(currentDate.getHours())
        + ":" + twoDigits(currentDate.getMinutes())
        + ":" + twoDigits(currentDate.getSeconds());
    return result;
}

const formatStandardWithTime = (date) => {
    if(!date 
        || date === "")
        return "";

    let formatedDate = formatStandard(date);
    let formatedTime = formatTime(date);

    return `${formatedDate} ${formatedTime}`;
}

const formatISO = (date) => {
    if(!date 
        || date === "")
        return "";

    let currentDate = new Date(date);
    let result = currentDate.getFullYear()
        + "-" + twoDigits(currentDate.getMonth() + 1) 
        + "-" + twoDigits(currentDate.getDate())
    return result;
}

const formatISOWithTime = (date) => {
    if(!date 
        || date === "")
        return "";

    let formatedDate = formatISO(date)
    let formatedTime = formatTime(date);

    return `${formatedDate}T${formatedTime}`;
}

const formatISOWithStartHour = (date) => {
    if(!date 
        || date === "")
        return "";

    date.setHours(0, 0, 0, 0);
    return formatISOWithTime(date);
}

const formatISOWithEndHour = (date) => {
    if(!date 
        || date === "")
        return "";

    date.setHours(23, 59, 59, 0);
    return formatISOWithTime(date);
}

export const formatDateManager = {
    formatStandard,
    formatTime,
    formatStandardWithTime,
    formatISO,
    formatISOWithTime,
    formatISOWithStartHour,
    formatISOWithEndHour,
    twoDigits
};